import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const HomeIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12.6306 5.30082C12.2632 5.00231 11.7368 5.00231 11.3694 5.30082L5.36941 10.1758C5.1357 10.3657 5 10.6508 5 10.9519V18C5 18.5523 5.44772 19 6 19H8.5V13.5C8.5 12.3954 9.39543 11.5 10.5 11.5H13.5C14.6046 11.5 15.5 12.3954 15.5 13.5V19H18C18.5523 19 19 18.5523 19 18V10.9519C19 10.6508 18.8643 10.3657 18.6306 10.1758L12.6306 5.30082ZM13.5 19V13.5H10.5V19H13.5ZM10.1082 3.74859C11.2104 2.85305 12.7896 2.85305 13.8918 3.74859L19.8918 8.62359C20.5929 9.19326 21 10.0485 21 10.9519V18C21 19.6568 19.6569 21 18 21H6C4.34315 21 3 19.6568 3 18V10.9519C3 10.0485 3.40709 9.19326 4.10822 8.62359L10.1082 3.74859Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

HomeIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(HomeIcon);
